(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gulf-country-picker"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.country-picker').forEach(picker=>{
  if(picker.dataset.bound)return;picker.dataset.bound='true';
  picker.addEventListener('keydown',event=>{if(event.key==='Escape'&&picker.open){picker.open=false;picker.querySelector('summary').focus();}});
  document.addEventListener('click',event=>{if(picker.open&&!picker.contains(event.target))picker.open=false;});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gulf-image-compare"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('glowtouch-compare')){
  customElements.define('glowtouch-compare',class extends HTMLElement{
    connectedCallback(){
      const input=this.querySelector('input[type="range"]');
      const frame=this.querySelector('.luna-compare__frame');
      if(!input||!frame)return;
      this.events?.abort();
      this.events=new AbortController();
      const options={signal:this.events.signal};
      let activePointer=null;
      const update=value=>{
        const position=Math.max(0,Math.min(100,Math.round(Number(value)||0)));
        input.value=String(position);
        this.style.setProperty('--compare-position',position+'%');
        this.dataset.position=String(position);
        input.setAttribute('aria-valuetext',position+'% '+this.dataset.beforeLabel+'، '+(100-position)+'% '+this.dataset.afterLabel);
      };
      const move=event=>{
        const bounds=frame.getBoundingClientRect();
        if(bounds.width)update((event.clientX-bounds.left)/bounds.width*100);
      };
      input.addEventListener('input',()=>update(input.value),options);
      input.addEventListener('keydown',()=>{this.dataset.inputMode='keyboard';},options);
      input.addEventListener('focus',()=>{if(input.matches(':focus-visible'))this.dataset.inputMode='keyboard';},options);
      input.addEventListener('pointerdown',event=>{
        if(!event.isPrimary||event.button!==0)return;
        input.focus({preventScroll:true});
        this.dataset.inputMode='pointer';
        activePointer=event.pointerId;
        input.setPointerCapture(event.pointerId);
        move(event);
        event.preventDefault();
      },options);
      input.addEventListener('pointermove',event=>{if(event.pointerId===activePointer)move(event);},options);
      for(const type of ['pointerup','pointercancel','lostpointercapture'])input.addEventListener(type,event=>{if(event.pointerId===activePointer)activePointer=null;},options);
      update(input.value);
      this.querySelector('[data-compare-ui]').hidden=false;
      this.querySelector('[data-compare-fallback]').hidden=true;
      this.querySelector('[data-compare-hint]').hidden=false;
      this.dataset.ready='true';
    }
    disconnectedCallback(){this.events?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
